// extracted by mini-css-extract-plugin
module.exports = {"loader":"ReactLoadableLoader_loader__3x1SD"};